/* eslint max-len: ["error", { "code": 130, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import '../css/DrawerLogo.css';

const DrawerLogo = ({theme, locale}) => (
    <div style={{backgroundColor: theme.objectTheme.palette.textColor}}>
        <img className="drawer-logo" src='static/images/Logo_GEK_T_W.png' alt="Logo"/>
        <h2 className="drawer-h2 h1-title-font" style={{color: theme.objectTheme.palette.textReverse}}>{locale.title}</h2>
    </div>
);

DrawerLogo.propTypes = {
    theme: PropTypes.object,
    locale: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    theme: state.theme,
    locale: state.locale.locale,
});

export default connect(
    mapStateToProps
)(DrawerLogo);



// WEBPACK FOOTER //
// ./src/components/DrawerLogo.js